<template>
  <div class="modal-dialog modal-fullscreen" role="document">
    <div class="modal-content">
      <div class="modal-header" id="login-modal-header">
        <button
          type="button"
          class="btn-close-modal"
          @click="changeView(view - 1, true)"
        >
          <i class="fas fa-arrow-left"></i>{{ transPeralbaPro.item781 }}
        </button>

        <img
          class="modal-title-img"
          src="/front/img/brand/peralba-positive.svg"
          alt="peralba-positive"
        />
      </div>
      <div class="modal-body" v-if="showFirst">
        <div class="first-col">
          <div class="content-ventajas">
            <h3>{{ transPeralbaPro.item782 }}</h3>
            <div class="item">
              <img
                class=""
                src="/front/hi/ventajas-pro-1.svg"
                alt="ventajas-pro-1"
              />
              <div>
                <p class="title-ventaja">{{ transPeralbaPro.item783 }}</p>
                <p
                  class="subtitle-ventaja"
                  v-html="transPeralbaPro.item784"
                ></p>
              </div>
            </div>
            <div class="item">
              <img
                class=""
                src="/front/hi/ventajas-pro-2.svg"
                alt="ventajas-pro-2"
              />
              <div>
                <p class="title-ventaja">{{ transPeralbaPro.item785 }}</p>
                <p
                  class="subtitle-ventaja"
                  v-html="transPeralbaPro.item786"
                ></p>
              </div>
            </div>
            <div class="item">
              <img
                class=""
                src="/front/hi/ventajas-pro-3.svg"
                alt="ventajas-pro-3"
              />
              <div>
                <p class="title-ventaja">{{ transPeralbaPro.item787 }}</p>
                <p
                  class="subtitle-ventaja"
                  v-html="transPeralbaPro.item788"
                ></p>
              </div>
            </div>
            <div class="item">
              <img
                class=""
                src="/front/hi/ventajas-pro-4.svg"
                alt="ventajas-pro-4"
              />
              <div>
                <p class="title-ventaja">{{ transPeralbaPro.item789 }}</p>
                <p
                  class="subtitle-ventaja"
                  v-html="transPeralbaPro.item790"
                ></p>
              </div>
            </div>
          </div>
        </div>
        <div class="second-col">
          <email-view
            v-if="view == 1"
            :email="loginForm.email"
            :password="loginForm.password"
            :route-check-email="routeCheckEmail"
            :route-login="routeLogin"
            :disabled-form="disabledForm"
            @multiLogin="multiLogin"
            @changeView="changeView"
            @updateField="handleEmail"
            @updateFieldPassword="handlePassword"
            @loading="handleLoading"
            :route-activate-customer="routeActivateCustomer"
            :trans-peralba-pro="transPeralbaPro"
          />
          <password-view
            v-if="view == 2"
            :email="loginForm.email"
            :password="loginForm.password"
            :forget-password="transPeralbaPro.item348"
            :route-login="routeLogin"
            :disabled-form="disabledForm"
            @updateField="handlePassword"
            @loading="handleLoading"
            @changeView="changeView"
            :trans-peralba-pro="transPeralbaPro"
          />
          <who-am-i-view
            v-if="view == 3"
            @clickParticular="clickParticular"
            @clickProfesional="clickProfesional"
            :trans-peralba-pro="transPeralbaPro"
          />
          <forget-password-view
            v-if="view == 4"
            :route-reset-password="routeResetPassword"
            :email="loginForm.email"
            :disabled-form="disabledForm"
            @updateField="handleEmail"
            @changeView="changeView"
            @loading="handleLoading"
            :trans-peralba-pro="transPeralbaPro"
          />
          <forget-password-success-view
            v-if="view == 5"
            :email="loginForm.email"
            :route-check-email="routeCheckEmail"
            :disabled-form="disabledForm"
            @showFirst="($event) => (this.showFirst = $event)"
            @changeView="changeView"
            :trans-peralba-pro="transPeralbaPro"
          />
          <register-success-view
            v-if="view == 6"
            :email="loginForm.email"
            :disabled-form="disabledForm"
            @showFirst="($event) => (this.showFirst = $event)"
            @changeView="changeView"
            :trans-peralba-pro="transPeralbaPro"
          />
          <multi-login
            v-if="view == 7"
            :currentId="currentId"
            :senderId="senderId"
            :platform="platform"
            :osVersion="osVersion"
            :appVersion="appVersion"
            :customers="customers"
            :route-multi-login="routeMultiLogin"
            @showFirst="($event) => (this.showFirst = $event)"
            @changeView="changeView"
            :trans-peralba-pro="transPeralbaPro"
          />
        </div>
      </div>

      <div class="modal-body" v-else>
        <professional-register-view
          v-if="isProfesional"
          :email="loginForm.email"
          :password="loginForm.password"
          :route-legal="routeLegal"
          :route-privacy="routePrivacy"
          :route-register="routeRegister"
          :route-sepa="routeSepa"
          :languages="languages"
          :activities="activities"
          :numberWorkers="numberWorkers"
          :warehouses="warehouses"
          :activity-workers="activityWorkers"
          :activity-general-workers="activityGeneralWorkers"
          :disabled-form="disabledForm"
          :payment-methods="paymentMethods"
          :default-selected-lang="defaultSelectedLang"
          :is-mobile="isMobile"
          :trans-peralba-pro="transPeralbaPro"
          @showFirst="($event) => (this.showFirst = $event)"
          @changeView="changeView"
          @loading="handleLoading"
        />

        <particular-register-view
          v-else
          :email="loginForm.email"
          :languages="languages"
          :activities="activities"
          :route-legal="routeLegal"
          :route-privacy="routePrivacy"
          :route-register="routeRegister"
          :disabled-form="disabledForm"
          :default-selected-lang="defaultSelectedLang"
          :is-mobile="isMobile"
          :trans-peralba-pro="transPeralbaPro"
          @showFirst="($event) => (this.showFirst = $event)"
          @changeView="changeView"
          @loading="handleLoading"
        />
        <!-- PARTICULAR -->
      </div>
    </div>
  </div>
</template>

<script>
import EmailView from "./views/EmailView";
import PasswordView from "./views/PasswordView";
import WhoAmIView from "./views/WhoAmIView";
import ForgetPasswordView from "./views/ForgetPasswordView";
import ForgetPasswordSuccessView from "./views/ForgetPasswordSuccessView";
import RegisterSuccessView from "./views/RegisterSuccessView";
import ProfessionalRegisterView from "./views/ProfessionalRegisterView";
import ParticularRegisterView from "./views/ParticularRegisterView";
import MultiLogin from "./views/MultiLogin";

export default {
  name: "login-modal",
  components: {
    EmailView,
    PasswordView,
    WhoAmIView,
    ForgetPasswordView,
    ForgetPasswordSuccessView,
    RegisterSuccessView,
    ProfessionalRegisterView,
    ParticularRegisterView,
    MultiLogin,
  },
  props: [
    "routeLogin",
    "routeMultiLogin",
    "routeCheckEmail",
    "routeReset",
    "routeCustomer",
    "routeLegal",
    "routeSepa",
    "routePrivacy",
    "routeResetPassword",
    "routeRegister",
    "routeRegistery",
    "routePrevious",
    "warehouses",
    "numberWorkers",
    "activityWorkers",
    "potentialPurchaseWorkers",
    "activityGeneralWorkers",
    "languages",
    "activities",
    "paymentMethods",
    "routeActivateCustomer",
    "defaultSelectedLang",
    "isMobile",
    "transPeralbaPro",
  ],
  data() {
    return {
      showFirst: true,
      view: 1,
      isProfesional: false,
      loading: false,
      customers: [],
      currentId: "",
      senderId: "",
      platrofm: "",
      osVersion: "",
      appVersion: "",
      loginForm: {
        email: "",
        password: "",
      },
    };
  },
  mounted() {
    let _self = this;
    $(this.$parent.$refs.vuemodal).on("hidden.bs.modal", function() {
      _self.showFirst = true;
      _self.view = 1;
    });
  },
  computed: {
    disabledForm() {
      if (this.loading) {
        return true;
      }
    },
  },
  methods: {
    handleLoading(isLoading) {
      this.loading = isLoading;
    },
    multiLogin(data) {
      this.customers = data.customers;
      this.currentId = data.id;
      this.senderId = data.sender_id;
      this.platform = data.platform;
      this.osVersion = data.os_version;
      this.appVersion = data.app_version;
    },
    changeView(view, isBack = false) {
      if (this.view == 7) {
        view = 1;
      } else if (this.view === 3 && isBack) {
        if (this.showFirst) {
          view = 1;
        } else {
          this.showFirst = true;
          view = 3;
        }
      }
      this.view = view;

      if (this.view === 0) {
        $(this.$parent.$refs.vuemodal).modal("hide");
      }
    },
    handleEmail(value) {
      this.loginForm.email = value;
    },
    handlePassword(value) {
      this.loginForm.password = value;
    },

    clickProfesional() {
      this.isProfesional = true;
      this.showFirst = false;
    },
    clickParticular() {
      this.isProfesional = false;
      this.showFirst = false;
    },
  },
};
</script>
